module.exports = __webpack_public_path__ + "static/img/cont59 (6).cc263d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont59 (6).jpg
// module id = e3Gl
// module chunks = 0